import { render } from "./SavedListDropdown.vue?vue&type=template&id=e8a6a9b0"
import script from "./SavedListDropdown.vue?vue&type=script&lang=js"
export * from "./SavedListDropdown.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__